"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Switch["default"];
  }
});
var _Switch = _interopRequireDefault(require("./Switch"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }